module.exports = __webpack_public_path__ + "img/Boeing-747-400.379bb733.png";